import BaseIcon from './BaseIcon';
import { ReactElement, SVGProps } from 'react';

export default function ClearFilterIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 32 32">
      <path
        d="M25.433 29.2 2.766 6.567a1.3 1.3 0 0 1-.4-.95q0-.55.4-.95t.95-.4.95.4L16 16l11.333 11.333q.4.4.4.934 0 .532-.4.933-.4.4-.95.4t-.95-.4m-3.767-11.867q-.566 0-.966-.383a1.26 1.26 0 0 1-.4-.95q0-.534.383-.933.384-.4.983-.4h1q.567 0 .95.383.384.383.384.95t-.384.95a1.3 1.3 0 0 1-.95.383zM15 10.667q-.567 0-.967-.384a1.26 1.26 0 0 1-.4-.95q0-.533.384-.933Q14.4 8 15 8h11.667q.566 0 .95.383.383.383.383.95t-.384.95a1.3 1.3 0 0 1-.95.384zM14.666 24a1.3 1.3 0 0 1-.95-.383 1.3 1.3 0 0 1-.383-.95q0-.567.383-.95a1.3 1.3 0 0 1 .95-.384h2.667q.567 0 .95.384.383.383.383.95 0 .566-.383.95a1.3 1.3 0 0 1-.95.383zm-5.333-6.667a1.3 1.3 0 0 1-.95-.383A1.3 1.3 0 0 1 8 16q0-.566.383-.95a1.3 1.3 0 0 1 .95-.383h4.2v2.666zm-4-6.666a1.3 1.3 0 0 1-.95-.384A1.3 1.3 0 0 1 4 9.333q0-.566.383-.95A1.3 1.3 0 0 1 5.333 8h1.533v2.667z"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
